module.exports = __webpack_public_path__ + "static/media/kr.pictogram.101972b3.svg";